<template>
  <div>
    <a-spin :spinning="loading">
      <a-table
        :columns="table.columns"
        :dataSource="table.data"
        :loading="table.loading"
        :rowSelection="rowSelection"
        :indentSize="13"
        :pagination="false"
        :defaultExpandAllRows="true"
        :expandedRowKeys="expandedRowKeys"
      >
        <template slot="selectBtn" slot-scope="record">
          <div v-if="record.btn&&record.btn.length>0" style="display:flex;">
            <div style="width:80px">
              <a-checkbox
                :indeterminate="record.indeterminate"
                @change="onCheckAllChange($event,record)"
                :checked="record.checkAll"
              >全选</a-checkbox>
            </div>
            <div style="width:85%">
              <a-checkbox-group
                :options="record.btn"
                v-model="record.btnSelected"
                @change="onChange($event,record)"
              />
            </div>

          </div>
        </template>
      </a-table>
      <div class="butt" v-if="$auth('role.menu')">
        <a-button @click="cancel" style="margin-right:8px">取消</a-button>
        <a-button type="primary" @click="handleSubmit">保存</a-button>
      </div>
    </a-spin>

  </div>
</template>

<script>
import { getRolePermissions, saveRolePermissions } from '@/api/roleList'
export default {
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '菜单名称',
            dataIndex: 'name',
            key: 'name'
          },
          {
            title: '操作',
            width: '68%',
            scopedSlots: { customRender: 'selectBtn' }
          }
        ]
      },
      // 选择的menu
      rowSelection: {
        selectedRowKeys: [],
        columnTitle: '#',
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.btnSelected = this.getBtns(this.table.data)
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows)
          if (selected === false) {
            record.btnSelected = []
            record.indeterminate = false
            record.checkAll = false
            if (record.children) {
              this.clearChildren(record.children)
              // console.log(this.rowSelection.selectedRowKeys)
            }
          } else {
            const familyKeys = this.familyTree(this.table.data, record.key)
            for (const i in familyKeys) {
              if (this.rowSelection.selectedRowKeys.indexOf(familyKeys[i]) === -1) {
                this.rowSelection.selectedRowKeys.push(familyKeys[i])
              }
            }
          }
        }
        // onSelectAll: (selected, selectedRows, changeRows) => {
        //     console.log(selected, selectedRows, changeRows);
        //     if(selected === false) {
        //         changeRows.map(item => {
        //             item.btnSelected = [];
        //             item.indeterminate = false;
        //             item.checkAll = false;
        //         })
        //     }
        // },
      },

      // 保存按钮
      //   isEdit: false,
      btnEdit: false,
      menuEdit: false,
      // 按钮初始选择
      btns: [],
      // 按钮变更选择
      btnSelected: [],
      // 菜单初始选择
      menus: [],
      // 初始展开行
      expandedRowKeys: [],
      loading: false
    }
  },
  watch: {
    btnSelected () {
      if (this.btnSelected.toString() !== this.btns.toString()) {
        this.btnEdit = true
      } else {
        this.btnEdit = false
      }
    },
    selectedRowKeys () {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        if (this.selectedRowKeys.toString() !== this.menus.toString()) {
          this.menuEdit = true
        } else {
          this.menuEdit = false
        }
      }
    },
    roleId () {
      this.initTreeData()
    }
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    selectedRowKeys () {
      return this.rowSelection.selectedRowKeys
    },
    isEdit () {
      return this.btnEdit || this.menuEdit
    }
  },
  methods: {
    // 初始化数据
    initTreeData () {
      const params = {
        roleId: this.roleId
      }
      this.loading = true
      getRolePermissions(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.menus
          this.rowSelection.selectedRowKeys = res.data.keys.map(i => {
            return i.menuId
          })
          this.menus = this.rowSelection.selectedRowKeys
          this.btns = this.getBtns(this.table.data)
          this.btnSelected = this.btns
          this.expandedRowKeys = this.getExpendKeys()
          this.getKeys(this.table.data)
          this.loading = false
        } else {
          this.loading = false
          this.$message.error('获取角色权限数据失败！')
        }
      }).catch(err => {
        this.loading = false
      })
    },
    onChange (checkedList, record) {
      this.btnSelected = this.getBtns(this.table.data)
      record.indeterminate = !!checkedList.length && checkedList.length < record.btn.length
      record.checkAll = checkedList.length === record.btn.length
      if (this.rowSelection.selectedRowKeys.indexOf(record.key) === -1) {
        this.rowSelection.selectedRowKeys.push(record.key)
      }
      const familyKeys = this.familyTree(this.table.data, record.key)
      for (const i in familyKeys) {
        if (this.rowSelection.selectedRowKeys.indexOf(familyKeys[i]) === -1) {
          this.rowSelection.selectedRowKeys.push(familyKeys[i])
        }
      }
    },
    onCheckAllChange (e, record) {
      const btnKeys = record.btn.map(i => {
        return i.value
      })
      Object.assign(record, {
        btnSelected: e.target.checked ? btnKeys : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
      if (e.target.checked) {
        if (this.rowSelection.selectedRowKeys.indexOf(record.key) === -1) {
          this.rowSelection.selectedRowKeys.push(record.key)
        }
        const familyKeys = this.familyTree(this.table.data, record.key)
        for (const i in familyKeys) {
          if (this.rowSelection.selectedRowKeys.indexOf(familyKeys[i]) === -1) {
            this.rowSelection.selectedRowKeys.push(familyKeys[i])
          }
        }
      }
      this.btnSelected = this.getBtns(this.table.data)
    },
    // 遍历树 获取所有展开项数组
    getExpendKeys () {
      const expend = []
      const getExp = (arr) => {
        for (const i in arr) {
          if (arr[i].children && arr[i].children.length > 0) {
            if (expend.indexOf(arr[i].key) === -1) {
              expend.push(arr[i].key)
            }
            getExp(arr[i].children)
          } else {
            delete arr[i].children
          }
        }
      }
      getExp(this.table.data)
      return expend
    },
    // 遍历树 获取key数组
    getKeys (datas) {
      for (const i in datas) {
        if (datas[i].btn && datas[i].btnSelected.length > 0) {
          if (this.rowSelection.selectedRowKeys.indexOf(datas[i].key) === -1) {
            this.rowSelection.selectedRowKeys.push(datas[i].key)
          }
          if (datas[i].pKey) {
            if (this.rowSelection.selectedRowKeys.indexOf(datas[i].pKey) === -1) {
              this.rowSelection.selectedRowKeys.push(datas[i].pKey)
            }
          }
          if (datas[i].btnSelected.length < datas[i].btn.length) {
            datas[i].indeterminate = true
            datas[i].checkAll = false
          } else if (datas[i].btnSelected.length === datas[i].btn.length) {
            datas[i].indeterminate = false
            datas[i].checkAll = true
          }
        } else {
          datas[i].indeterminate = false
          datas[i].checkAll = false
        }
        if (datas[i].children && datas[i].children.length > 0) {
          this.getKeys(datas[i].children)
        }
      }
    },
    // 遍历树，获取父元素key数组
    familyTree (datas, key) {
      const temp = []
      const forFn = function (arr, key) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (item.key === key) {
            temp.push(item.key)
            forFn(datas, item.pKey)
            break
          } else {
            if (item.children && item.children.length > 0) {
              forFn(item.children, key)
            }
          }
        }
      }
      forFn(datas, key)
      return temp
    },
    // 清空children
    clearChildren (child) {
      for (const i in child) {
        child[i].btnSelected = []
        child[i].indeterminate = false
        child[i].checkAll = false
        for (const j in this.rowSelection.selectedRowKeys) {
          if (this.rowSelection.selectedRowKeys[j] === child[i].key) {
            this.rowSelection.selectedRowKeys.splice(j, 1)
          }
        }
        if (child[i].children && child[i].children.length > 0) {
          this.clearChildren(child[i].children)
        }
      }
    },
    // 遍历获取所有选中按钮
    getBtns (datas) {
      let btns = []
      const forBtn = (arr) => {
        for (const i in arr) {
          const item = arr[i]
          if (item.btnSelected.length > 0) {
            btns = btns.concat(item.btnSelected)
          }
          if (item.children && item.children.length > 0) {
            forBtn(item.children)
          }
        }
      }
      forBtn(datas)
      return btns
    },
    // 取消保存
    cancel () {
      this.initTreeData()
    },
    // 保存提交
    handleSubmit () {
      const params = {
        roleId: this.roleId,
        menuIdList: this.rowSelection.selectedRowKeys,
        btnIdList: this.getBtns(this.table.data)
      }
      saveRolePermissions(params).then(res => {
        if (res.status === 0) {
          this.$message.success('权限修改保存成功！')
          this.initTreeData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  },
  mounted () {
    this.initTreeData();
  }
}
</script>

<style scoped lang="less">
.butt {
  display:flex;
  position: fixed;
  bottom: 80px;
  right: 70px;
}
</style>
